<label for="uploadFile" class="kaizen-attachment-label" >Kaizen Attachments</label>
<br>
  <div class="custom-file">

    <input type="file" class="custom-file-input" id="uploadFile" (change)="fileUploadChanged($event)"
      onclick="this.value = null" required [disabled]="this.kaizenID == 0">
      <label for="uploadFile" class="custom-file-label">{{fileSelectionBoxLabel}}</label>
      <div class="invalid">{{errorMessage}}</div>
    </div>

    <table class="table table-condensed">
      <thead>
        <tr>
          <th scope="col">Id</th>
          <th scope="col">File Name</th>
          <th scope="col">View</th>
          <th scope="col">Delete</th>
        </tr>
      </thead>
      <tbody>
        @for (attachment of Attachments; track attachment; let i = $index) {
          <tr>
            <ng-container>
              <td>{{i+1}}</td>
              <td>{{attachment.attachmentName}}</td>
              <td><mat-icon class="link-primary" (click)="downloadAttachment(attachment.attachmentName, attachment.kaizenID)">pageview</mat-icon></td>
              <td>
                <mat-icon class="link-primary" (click)="DeleteAttachment(attachment.kaizenAttachmentID, attachment.attachmentName)">delete_outline</mat-icon>
              </td>
            </ng-container>
          </tr>
        }
      </tbody>
    </table>